import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';

import { DxDataGridComponent } from 'devextreme-angular';
import { EntityQuery } from 'breeze-client';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from '@angular/router';
import { confirm, alert } from 'devextreme/ui/dialog';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { AppInformationService, AuthenticationService, RAFUnitOfWork } from 'src/app/core/core.module';
import { Job, JobStatus, User } from 'src/app/core/data/entities';
import { MaterialDialogComponent } from '../material-dialog/material-dialog.component';
import { Location } from '@angular/common';
import { InputDialogComponent } from 'src/app/shared/shared.module';
import { TimeDialogComponent } from '../time-dialog/time-dialog.component';
import { PurchaseOrderLineDialogComponent } from '../purchase-order-line-dialog/purchase-order-line-dialog.component';


@Component({
    selector: 'app-job-detail',
    templateUrl: './job-detail.component.html',
    styleUrls: ['./job-detail.component.scss'],
    standalone: false
})
export class JobDetailComponent implements OnInit {
    jobId: any;
    job: any;
    materials: any;
    timeEntries: any;
    workOrderList: any[];
    showAllOrders = false;
    canSeePurchaseOrderLineGrid = false;
    canSeeCompleteJob = false;
    filter: any;
    purchaseOrderLines: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: RAFUnitOfWork,
        private router: Router,
        private route: ActivatedRoute,
        public auth: AuthenticationService,
        private appInfo: AppInformationService,
        private modalService: BsModalService,
        protected location: Location,

    ) { }

    async ngOnInit() {
        const employees = await this.uow.getEmployees();
        this.canSeePurchaseOrderLineGrid = this.auth.hasRole('Admin') || this.auth.hasRole('BillingAdmin');
        this.canSeeCompleteJob = this.auth.hasRole('JobAdmin');
        await this.getData();
    }

    async getData() {
        this.jobId = this.route.snapshot.params.id;
        this.job = (await this.uow.jobs.byId(this.jobId)) as Job;
        if(!!this.job)
        {
            const purchaseOrderLines = await this.uow.getPurchaseOrderLinesByJobId(this.job.id);
            this.purchaseOrderLines = purchaseOrderLines;
            // this.purchaseOrderLines = this.job.purchaseOrderLines.filter(x => { return !x.deleted });

            const jobMaterials = await this.uow.getJobMaterialsByJobId(this.job.id, 100);
            this.materials = jobMaterials;
            // this.materials = this.job.jobMaterials.filter(x => {
            //     return !x.deleted;
            // });
            const timeEntries = await this.uow.getTimeEntriesByJobId(this.job.id, 100);
            this.timeEntries = timeEntries;
            // this.timeEntries = this.job.timeEntries.filter(x => {
            //     return !x.deleted;
            // });
        }
    }

    selectionChange(e) { }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    close() {
        try {
            this.location.back();
        } catch {
            this.router.navigate(['../'], { relativeTo: this.route });
        }
    }

    viewNotes() {
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                // jobId: this.job.id,
                dialogHeader: 'Job Notes',
                dialogValue: this.job.note,
                mode: 'textarea',
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                this.job.note = result.value;
                await this.uow.commit();
            }
            modalRef.hide();
            this.appInfo.pleaseWaitHide();
        });
    }

    async completeJob() {
        const result = await (confirm('Are you sure you want to COMPLETE this job?', `${this.appInfo.settings.company}`) as Promise<boolean>);
        if (!!result) {
            this.appInfo.pleaseWaitShow();
            this.job.completed = new Date();
            this.job.completedById = this.auth.userValue.id;
            this.job.statusId = JobStatus.Statuses.Complete;
            this.job.jobTypeId = 4;

            await this.uow.commit();
            await this.getData();
            this.appInfo.pleaseWaitHide();
            this.close();
        }
    }

    async onRowDblClick(e) {
        this.addPurchaseOrder(e.data);
    }

    async addPurchaseOrder(purchaseOrderLine?: any) {
        const modalRef = this.modalService.show(PurchaseOrderLineDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                jobId: this.job.id,
                purchaseOrderLine: purchaseOrderLine,
                isJobDisabled: true
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                await this.uow.commit();
                await this.getData();
            }
            modalRef.hide();
            this.appInfo.pleaseWaitHide();
        });
    }

    async addMaterial() {
        const modalRef = this.modalService.show(MaterialDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                jobId: this.job.id,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                await this.uow.commit();
                await this.getData();
            }
            modalRef.hide();
            this.appInfo.pleaseWaitHide();
        });
    }

    async addTime() {
        const modalRef = this.modalService.show(TimeDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                jobId: this.job.id,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                await this.uow.commit();
                await this.getData();
            }
            modalRef.hide();
            this.appInfo.pleaseWaitHide();
        });
    }
    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        const filter = e.component.getCombinedFilter();
        if (e.component.__searchChanged || !!filter) {
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

    async onCellClick(e) {}



    async delete(selection: any) {
        const result = await (confirm('Are you sure you want to DELETE this item?', `${this.appInfo.settings.company}`) as Promise<boolean>);
        if (!!result) {
            this.appInfo.pleaseWaitShow();
            selection.deleted = new Date();
            selection.deletedById = this.auth.userValue.id;
            await this.uow.commit();
            await this.getData();
            this.appInfo.pleaseWaitHide();
        }
    }

    async updateStatus() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (selectedRows.length === 0) return;

        const result = await (confirm(
            `Are you sure you want to COMPLETE ${selectedRows.length === 1 ? 'this order' : 'these orders'}?`,
            `${this.appInfo.settings.company}`
        ) as Promise<boolean>);
        if (!result) return;

        const orderIds = selectedRows.map((x) => {
            return x.id;
        });

        selectedRows.forEach((row) => {
            row.statusId = 1;
        });
        await this.uow.commit();
        await this.getData();
    }
}
